import _ from 'lodash';

import * as api from '../../../../api';

export const findAllProviders = _.memoize((organizationId: string) =>
  api.client.PrevisitProvider.findAllByOrganizationId(organizationId),
);
